import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import DashboardLayout from '@components/layout/DashboardLayout'
import { DashboardErrorBoundary } from '@components/ErrorBoundary'
import RevenueDashboard from './RevenueDashboard'
import FinancialReports from './FinancialReports'
import GUIAgentStatus from './GUIAgentStatus'
import StoreComparison from './StoreComparison'

const OwnerPortal: React.FC = () => {
  const menuItems = [
    { path: 'revenue', label: 'Revenue Intelligence', icon: 'TrendingUp' },
    { path: 'reports', label: 'Financial Reports', icon: 'Assessment' },
    { path: 'stores', label: 'Store Comparison', icon: 'Store' },
    { path: 'status', label: 'System Status', icon: 'Speed' }
  ]

  return (
    <DashboardLayout title="TanOak Owner Portal" menuItems={menuItems}>
      <Box sx={{ p: 3 }}>
        <Routes>
          <Route path="/" element={<Navigate to="revenue" replace />} />
          <Route path="revenue" element={
            <DashboardErrorBoundary>
              <RevenueDashboard />
            </DashboardErrorBoundary>
          } />
          <Route path="reports" element={
            <DashboardErrorBoundary>
              <FinancialReports />
            </DashboardErrorBoundary>
          } />
          <Route path="stores" element={
            <DashboardErrorBoundary>
              <StoreComparison />
            </DashboardErrorBoundary>
          } />
          <Route path="status" element={
            <DashboardErrorBoundary>
              <GUIAgentStatus />
            </DashboardErrorBoundary>
          } />
        </Routes>
      </Box>
    </DashboardLayout>
  )
}

export default OwnerPortal